import React from 'react'
import Shineyeffect from './Shineyeffect'
function Services() {
  return (
    <section id="services" className='overflow-x-hidden'>
        <div className='container lg:pt-5'>
            <div className='text-center'>
                <h2 className='text-sky-500 font-[800] text-[2.4rem] mb-5 '>
                    What do I help
                </h2>
                <p className=' text-gray-500 font-[500] text-[16px] leading-7 '>
                I specialize in leveraging automation to streamline processes and optimize workflows. From front-end development for captivating user interfaces to back-end expertise ensuring seamless functionality, I help businesses achieve efficiency and effectiveness. With a knack for web scraping, I extract valuable insights to inform strategic marketing decisions. Let's automate and innovate together                </p>
            </div>
            <div className='flex flex-col justify-center sm:py-12 '>
                <div className='w-full py-3 px-2 sm:max-w-xl sm:mx-auto sm:px-0 '>
                    <div className='relative text-gray-900 antialiased text-sm font-semibold '>
                        {/**   Vertical Line  */}
                        <div className="hidden absolute w-1 sm:block bg-sky-400 h-full left-1/2 transform -translate-x-1/2">
                        </div>
                        {/** Left Card */}
                        <div className='mt-6 sm:mt-0 sm:mb-12'>
                            <div className='flex items-center flex-col sm:flex-row '>
                                <div className='w-full sm:w-1/2 sm:pr-8'>
                                    <div 
                                    data-aos="fade-left"
                                    data-aos-delay='100'
                                    data-aos-duration='1400' 
                                    className='bg-white p-4 rounded shadow group hover:bg-sky-600 cursor-pointer ease-in-out duration-300'>
                                        <h3 className='text-sky-600 font-[600] mb-3 group-hover:text-white 
                                            group-hover:font-[500] text-2xl '>FrontEnd development</h3>
                                        <p className='text-[15px] text-sky-300 group-hover:text-white group-hover:font-[500]'>
                                        Front-end development using React and Next.js, augmented with animation libraries to elevate websites to a professional standard                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/** Right Card */}
                        <div className='mt-6 sm:mt-0 sm:mb-12'>
                            <div className='flex items-center flex-col sm:flex-row justify-end'>
                                <div className='w-full sm:w-1/2 sm:pl-8'>
                                    <div
                                    data-aos="fade-right"
                                    data-aos-delay='100'
                                    data-aos-duration='1400'  
                                    className='bg-white p-4 rounded shadow group hover:bg-sky-600 cursor-pointer ease-in-out duration-300'>
                                        <h3 className='text-sky-600 font-[600] mb-3 group-hover:text-white 
                                            group-hover:font-[500] text-2xl '>BackEnd development</h3>
                                        <p className='text-[15px] text-sky-300 group-hover:text-white group-hover:font-[500]'>
                                        Back-end expertise anchored in Node.js and Express, with MongoDB as the powerhouse database. Crafting robust, scalable solutions to drive your applications forward.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/** Second Left */}
                        <div className='mt-6 sm:mt-0 sm:mb-12'>
                            <div className='flex items-center flex-col sm:flex-row justify-start'>
                                <div className='w-full sm:w-1/2 sm:pr-8'>
                                    <div
                                    data-aos="fade-right"
                                    data-aos-delay='100'
                                    data-aos-duration='1400'  
                                    className='bg-white p-4 rounded shadow group hover:bg-sky-600 cursor-pointer ease-in-out duration-300'>
                                        <h3 className='text-sky-600 font-[600] mb-3 group-hover:text-white 
                                            group-hover:font-[500] text-2xl '>Automation development</h3>
                                        <p className='text-[15px] text-sky-300 group-hover:text-white group-hover:font-[500]'>
                                        Automation maestro wielding Python and Selenium to orchestrate seamless, efficient processes. Empowering businesses with automated solutions that optimize performance and productivity
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/** Second right */}
                        <div className='mt-6 sm:mt-0 sm:mb-12'>
                            <div className='flex items-center flex-col sm:flex-row justify-end'>
                                <div className='w-full sm:w-1/2 sm:pl-8'>
                                    <div
                                    data-aos="fade-right"
                                    data-aos-delay='100'
                                    data-aos-duration='1400'  
                                    className='bg-white p-4 rounded shadow group hover:bg-sky-600 cursor-pointer ease-in-out duration-300'>
                                        <h3 className='text-sky-600 font-[600] mb-3 group-hover:text-white 
                                            group-hover:font-[500] text-2xl '>Webscrapping</h3>
                                        <p className='text-[15px] text-sky-300 group-hover:text-white group-hover:font-[500]'>
                                        Webscraping aficionado, harnessing the power of Python to extract valuable insights from the web. Transforming raw data into actionable intelligence for informed decision-making                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>  
                </div>
            </div>
            <div className='hidden md:block'>
                <Shineyeffect left={100} top={1300} size={1200}/>
                <Shineyeffect left={100} top={1300} size={1200}/>

            </div>
        </div>
    </section>
  )
}

export default Services